'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M532.054 244.052c-42.41 41.142-128.196 126.27-143.268 141.358-117.626 117.614-393.8 445.24-388.714 638.52 193.28 5.102 520.896-271.094 638.526-388.708 15.088-15.090 100.216-100.882 141.346-143.28l-247.89-247.89zM944.678 204.18l-18.044-18.014 97.366-80.444-105.72-105.722-80.444 97.372-18.036-18.078c-55.792-3.262-145.764 50.75-234.43 122.080l237.258 237.26c26.828-33.376 51.048-66.866 70.844-98.712 59.528 49.078 15.528 193.078-235.67 381.882l46.198 46.196c224-160 369-352 228.526-504.46 8.378-22.158 13.142-42.464 12.152-59.36z' })
    ));
};